import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import CounterpartiesApi from '@/services/apiServiceModules/counterpartiesApi.js'
const counterpartiesApi = new CounterpartiesApi()

export default class CounterpartiesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.COUNTERPARTIES, counterpartiesApi, {
			useCache: true,
		})
	}
}
